// Never enable in production, use locally: both capture a stack trace on every call
// (every addEventListener / every sneakyPromise) which costs hundreds of ms on a board render.
const PROFILE_EVENT_LISTENERS = false;
const PROFILE_UNRESOLVED_PROMISES = false;

const listenersProfiler = () => {
  const listenerMap = new Map();

  function getCallerLocation() {
    const stack = new Error().stack?.split('\n').slice(3); // 0: Error, 1: getCallerLocation, 2: addEventListener
    for (const line of stack) {
      const match = line.match(/\((.*?):(\d+):(\d+)\)/) || line.match(/at (.*?):(\d+):(\d+)/);
      if (match) {
        const [_, file, lineNum] = match;
        return `${file}:${lineNum}`;
      }
    }
    return 'unknown';
  }

  const originalAdd = EventTarget.prototype.addEventListener;
  const originalRemove = EventTarget.prototype.removeEventListener;

  EventTarget.prototype.addEventListener = function(type, listener, options) {
    const key = getCallerLocation();
    const bucket = listenerMap.get(key) || { count: 0, listeners: new WeakMap() };
    if (listener && typeof listener === 'object' && !bucket.listeners.has(listener)) {
      bucket.count++;
      bucket.listeners.set(listener, true);
      listenerMap.set(key, bucket);
    }
    return originalAdd.call(this, type, listener, options);
  };

  EventTarget.prototype.removeEventListener = function(type, listener, options) {
    for (const [key, bucket] of listenerMap.entries()) {
      if (bucket.listeners.has(listener)) {
        bucket.listeners.delete(listener);
        bucket.count--;
        if (bucket.count <= 0) listenerMap.delete(key);
        break;
      }
    }
    return originalRemove.call(this, type, listener, options);
  };

  setInterval(() => {
    const top = [...listenerMap.entries()]
      .sort((a, b) => b[1].count - a[1].count)
      .slice(0, 10);
    console.log('%c[Top 10 Active Event Listeners]', 'color: limegreen; font-weight: bold');
    top.forEach(([location, data], i) => {
      console.log(`#${i + 1} (${data.count}) ${location}`);
    });
  }, 5 * 60_000); 
};


// Global state for promise tracking
const promiseMap = new Map();
let activePromiseCount = 0;

function getCallerLocation() {
  const stack = new Error().stack?.split('\n');
  for (let i = 0; i < stack.length; i++) {
    const line = stack[i];
    const match = line.match(/\((.*?):(\d+):(\d+)\)/) || line.match(/at (.*?):(\d+):(\d+)/);
    if (match) {
      const [_, file, lineNum, colNum] = match;
      // Skip internal files and this profiling file
      if (!file.includes('profiling.js') && 
          !file.includes('webpack-internal') && 
          !file.includes('node_modules') &&
          !line.includes('sneakyPromise')) {
        return `${file}:${lineNum}`;
      }
    }
  }
  return 'unknown';
}

export function sneakyPromise(callback) {
  if (!PROFILE_UNRESOLVED_PROMISES) {
    return new Promise(callback);
  }
  const location = getCallerLocation();
  activePromiseCount += 1;

  const bucket = promiseMap.get(location) || { count: 0 };
  bucket.count++;
  promiseMap.set(location, bucket);

  return new Promise((resolve, reject) => {
    function rsv(args) {
      activePromiseCount -= 1;
      bucket.count--;
      if (bucket.count <= 0) promiseMap.delete(location);
      resolve(args);
    }
    function rej(args) {
      activePromiseCount -= 1;
      bucket.count--;
      if (bucket.count <= 0) promiseMap.delete(location);
      reject(args);
    }
    callback(rsv, rej);
  });
}

export function getActivePromiseCount() {
  return activePromiseCount;
}

const initPromiseWrappers = () => {
  setInterval(() => {
    const top = [...promiseMap.entries()]
      .sort((a, b) => b[1].count - a[1].count)
      .slice(0, 10);
    console.log('%c[Top 10 Unresolved Promises]', 'color: orange; font-weight: bold');
    top.forEach(([location, data], i) => {
      console.log(`#${i + 1} (${data.count}) ${location}`);
    });
  }, 5 * 60_000); // every 60 seconds
};

export function initProfiling() {
  if (PROFILE_EVENT_LISTENERS) listenersProfiler();
  if (PROFILE_UNRESOLVED_PROMISES) initPromiseWrappers();
}